import React from 'react';
import { useEffect } from 'react';
import { useSubscription } from '@apollo/client';
import { useSelector } from 'react-redux';

import { IDB_ENTITY_REFERENCE_SUBSCRIPTION, IDB_USER_REFERENCE_SUBSCRIPTION } from './IDBSubscriptions';
import { updateOrAddEntityReference, updateOrAddUserReference } from './affectliIDB';

const OfflineSubscriptions = () => {
    const { data: entityReference } = useSubscription(IDB_ENTITY_REFERENCE_SUBSCRIPTION);
    const { data: userReference } = useSubscription(IDB_USER_REFERENCE_SUBSCRIPTION);

    useEffect(() => {
        if (entityReference?.data) {
            updateOrAddEntityReference(entityReference?.data);
        }
    }, [entityReference]);

    useEffect(() => {
        if (userReference?.data) {
            updateOrAddUserReference(userReference?.data);
        }
    }, [userReference]);

    return null;
};

/**
 * OfflineCacheSubscriptions Component
 *
 * Purpose:
 * This component serves as a conditional wrapper for managing offline specific subscriptions.
 * It checks the application's `isOfflineModeOn` state from the Redux store to determine
 * whether to render the `OfflineSubscriptions` component.
 *
 * Key Features:
 * - Automatically unsubscribes from all subscriptions inside `OfflineSubscriptions` when
 *   the component unmounts, leveraging React's cleanup behavior.
 * - Provides a clean and declarative way to manage offline subscriptions based on application state.
 */
const OfflineCacheSubscriptions = () => {
    const isOfflineModeOn = useSelector(state => state.app.isOfflineModeOn);
    if (isOfflineModeOn) {
        return <OfflineSubscriptions />;
    }
    return null;
};

export default OfflineCacheSubscriptions;
